/* Zahe Elegance – JavaScript del tema */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => new Intl.NumberFormat(window.theme.locale || 'es', { style: 'currency', currency: window.theme.currency || 'EUR' }).format(cents / 100);
  const titleCase = (s) => String(s || '').split(/\s+/).join(' ').toLowerCase().replace(/^./, (c) => c.toUpperCase());

  /* ---------- Barra de avisos ---------- */
  function initRotator(root = document) {
    $$('[data-rotator]', root).forEach((track) => {
      if (track._timer) clearInterval(track._timer);
      const n = track.children.length;
      if (n < 2) return;
      let i = 0;
      track._timer = setInterval(() => {
        i = (i + 1) % n;
        track.style.transform = `translateY(-${i * track.children[0].offsetHeight}px)`;
      }, 4000);
    });
  }

  /* ---------- Cabecera, buscador y menú móvil ---------- */
  function initHeader() {
    const header = $('#SiteHeader');
    if (header) addEventListener('scroll', () => header.classList.toggle('scrolled', scrollY > 40), { passive: true });

    const drawer = $('#MenuDrawer');
    const setDrawer = (open) => {
      if (!drawer) return;
      drawer.classList.toggle('open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-drawer-open]')) setDrawer(true);
      else if (e.target.closest('[data-drawer-close]')) setDrawer(false);

      const st = e.target.closest('[data-search-toggle]');
      if (st) {
        const bar = $('#SearchBar');
        if (!bar) return;
        bar.hidden = !bar.hidden;
        st.setAttribute('aria-expanded', String(!bar.hidden));
        if (!bar.hidden) $('input[type=search]', bar).focus();
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setDrawer(false); $$('[data-sg]').forEach((m) => m.classList.remove('open')); } });
  }

  /* ---------- Animación de entrada ---------- */
  let io;
  function initReveal(root = document) {
    if (!('IntersectionObserver' in window)) { $$('.reveal', root).forEach((el) => el.classList.add('in')); return; }
    io = io || new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.12 });
    $$('.reveal:not(.in)', root).forEach((el) => io.observe(el));
    if (window.Shopify && Shopify.designMode) $$('.reveal', root).forEach((el) => el.classList.add('in'));
  }

  /* ---------- Pestañas de productos y lookbook ---------- */
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach((sec) => {
      $$('[data-tab]', sec).forEach((btn) => btn.addEventListener('click', () => {
        $$('[data-tab]', sec).forEach((b) => b.classList.toggle('active', b === btn));
        $$('[data-panel]', sec).forEach((p) => {
          const on = p.dataset.panel === btn.dataset.tab;
          p.hidden = !on;
          if (on) { p.classList.remove('fade'); void p.offsetWidth; p.classList.add('fade'); }
        });
      }));
    });
    $$('[data-lookbook]', root).forEach((sec) => {
      $$('[data-look]', sec).forEach((btn) => btn.addEventListener('click', () => {
        $$('[data-look]', sec).forEach((b) => b.classList.toggle('active', b === btn));
        $$('[data-look-panel]', sec).forEach((p) => { p.hidden = p.dataset.lookPanel !== btn.dataset.look; });
      }));
    });
  }

  /* ---------- Página de colección ---------- */
  function initCollection(root = document) {
    const wrap = $('[data-collection]', root);
    if (!wrap) return;
    const form = $('[data-facets]', wrap);
    const layout = $('[data-layout]', wrap);
    const grid = $('[data-grid]', wrap);

    const go = () => {
      const params = new URLSearchParams(new FormData(form));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      const sort = $('[data-sort]', wrap);
      if (sort) params.set('sort_by', sort.value);
      location.href = `${form.getAttribute('action')}?${params.toString()}`;
    };
    if (form) {
      form.addEventListener('change', go);
      form.addEventListener('submit', (e) => { e.preventDefault(); go(); });
    }
    const sort = $('[data-sort]', wrap);
    if (sort) sort.addEventListener('change', go);

    const toggle = $('[data-filters-toggle]', wrap);
    if (toggle) toggle.addEventListener('click', () => {
      if (innerWidth <= 860) layout.classList.toggle('show-f');
      else {
        layout.classList.toggle('nofilters');
        if (!layout.classList.contains('nofilters') && grid.classList.contains('g4')) setCols(3);
      }
    });
    const setCols = (n) => {
      grid.classList.remove('g2', 'g3', 'g4');
      grid.classList.add(`g${n}`);
      $$('[data-cols]', wrap).forEach((b) => b.classList.toggle('active', +b.dataset.cols === n));
      try { localStorage.setItem('zahe-cols', n); } catch (e) {}
    };
    $$('[data-cols]', wrap).forEach((b) => b.addEventListener('click', () => setCols(+b.dataset.cols)));
    try { const saved = +localStorage.getItem('zahe-cols'); if (saved) setCols(saved); } catch (e) {}
    if (layout && !layout.classList.contains('nofilters') && innerWidth > 860 && grid.classList.contains('g4')) setCols(3);
  }

  /* ---------- Ficha de producto ---------- */
  function initProduct(root = document) {
    const wrap = $('[data-product]', root);
    if (!wrap) return;
    const form = $('#ProductForm', wrap);
    const variants = JSON.parse(($('[data-variants]', wrap) || {}).textContent || '[]');
    const idInput = $('[data-variant-id]', wrap);
    const addBtn = $('[data-add]', wrap);
    const msg = $('[data-msg]', wrap);
    const sizeIndex = +wrap.dataset.sizeIndex;
    const groups = $$('[data-option]', wrap);

    let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];
    const state = current ? current.options.slice() : [];
    if (wrap.dataset.sizeRequired === 'true' && sizeIndex > -1) state[sizeIndex] = null;

    const match = (opts) => variants.find((v) => v.options.every((o, i) => opts[i] == null || opts[i] === o));
    const exact = () => (state.every((o) => o != null) ? variants.find((v) => v.options.every((o, i) => o === state[i])) : null);

    function update() {
      // Disponibilidad de cada botón según el resto de opciones elegidas
      groups.forEach((g) => {
        const idx = +g.dataset.option;
        $$('.size', g).forEach((b) => {
          const test = state.slice(); test[idx] = b.dataset.value;
          const v = variants.find((x) => x.options.every((o, i) => test[i] == null || test[i] === o) && x.available);
          b.classList.toggle('out', !v);
          b.classList.toggle('sel', state[idx] === b.dataset.value);
        });
        const label = $('[data-opt-label]', g);
        if (label) label.textContent = state[idx] != null ? titleCase(state[idx].split('-')[0]) : 'Selecciona tu talla';
      });

      const v = exact();
      if (!v) {
        addBtn.disabled = false;
        addBtn.textContent = 'Selecciona una talla';
        addBtn.dataset.needsSize = 'true';
        const preview = match(state);
        if (preview) renderPrice(preview);
        return;
      }
      delete addBtn.dataset.needsSize;
      current = v;
      idInput.value = v.id;
      renderPrice(v);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Añadir a la cesta' : 'Agotado';
      if (v.featured_media) showMediaById(v.featured_media.id);
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
    function renderPrice(v) {
      const p = $('[data-price]', wrap);
      if (p) p.innerHTML = v.compare_at_price > v.price
        ? `<s class="price-was">${money(v.compare_at_price)}</s> <span class="price-sale">${money(v.price)}</span>`
        : `<span>${money(v.price)}</span>`;
      const sp = $('[data-sticky-price]', wrap);
      if (sp) sp.textContent = money(v.price);
    }

    groups.forEach((g) => {
      const idx = +g.dataset.option;
      $$('.size', g).forEach((b) => b.addEventListener('click', () => {
        if (b.classList.contains('out') && idx === sizeIndex) {
          msg.textContent = `La talla ${b.textContent.trim()} está agotada.`;
          return;
        }
        msg.textContent = '';
        state[idx] = b.dataset.value;
        update();
      }));
    });
    // Galería (2 columnas en ordenador, deslizable en móvil)
    const main = $('[data-main]', wrap);
    const items = main ? $$('.gallery__item', main) : [];
    function showMediaById(id) {
      const pos = (window.__zaheMedia || []).indexOf(id);
      if (pos > -1 && items[pos] && innerWidth <= 860) main.scrollTo({ left: items[pos].offsetLeft, behavior: 'smooth' });
    }
    update();

    // Cantidad
    const qtyInput = $('[data-qty-input]', wrap);
    $$('[data-qty]', wrap).forEach((b) => b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (+qtyInput.value || 1) + +b.dataset.qty);
    }));

    // Añadir a la cesta sin recargar
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (addBtn.dataset.needsSize) {
        msg.textContent = 'Por favor, selecciona una talla.';
        $('.sizes', groups[sizeIndex] || wrap)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      addBtn.disabled = true;
      const label = addBtn.textContent;
      addBtn.textContent = 'Añadiendo…';
      try {
        const res = await fetch(`${window.theme.routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'No se ha podido añadir');
        msg.textContent = '';
        showToast(data);
        refreshCount();
      } catch (err) {
        msg.textContent = err.message;
      } finally {
        addBtn.disabled = false;
        addBtn.textContent = label;
      }
    });

    // Barra fija en móvil
    const sticky = $('[data-sticky]', wrap);
    const buyRow = $('#BuyRow', wrap);
    if (sticky && buyRow) {
      addEventListener('scroll', () => sticky.classList.toggle('show', buyRow.getBoundingClientRect().bottom < 0), { passive: true });
      $('[data-sticky-add]', sticky).addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }

    // Guía de tallas
    const sg = $('[data-sg]', wrap);
    $$('[data-sg-open]', wrap).forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); sg.classList.add('open'); }));
    if (sg) sg.addEventListener('click', (e) => { if (e.target === sg || e.target.closest('[data-sg-close]')) sg.classList.remove('open'); });
  }

  function showToast(item) {
    const t = $('#CartToast');
    if (!t) return;
    const img = $('img', t);
    if (item.image) { img.src = item.image; img.hidden = false; } else img.hidden = true;
    const opts = (item.options_with_values || []).filter((o) => o.value !== 'Default Title').map((o) => titleCase(o.value.split('-')[0]));
    $('p', t).textContent = [titleCase(item.product_title), ...opts].join(' · ') + ` · x${item.quantity}`;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('show'), 3500);
  }
  async function refreshCount() {
    try {
      const cart = await (await fetch(`${window.theme.routes.cart_url}.js`)).json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    } catch (e) {}
  }

  /* ---------- Cesta ---------- */
  function initCart(root = document) {
    const form = $('#CartForm', root);
    if (!form) return;
    let timer;
    const submitUpdate = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const fd = new FormData(form);
        fd.set('update', '1');
        fetch(form.action, { method: 'POST', body: fd }).then(() => location.reload());
      }, 450);
    };
    $$('[data-cart-qty]', form).forEach((b) => b.addEventListener('click', () => {
      const input = $('[data-cart-input]', b.parentElement);
      input.value = Math.max(0, (+input.value || 0) + +b.dataset.cartQty);
      submitUpdate();
    }));
    $$('[data-cart-input]', form).forEach((i) => i.addEventListener('change', submitUpdate));
  }

  function initAll(root = document) {
    initRotator(root);
    initReveal(root);
    initTabs(root);
    initCollection(root);
    initProduct(root);
    initCart(root);
  }

  document.addEventListener('DOMContentLoaded', () => { initHeader(); initAll(); });
  // Editor de temas de Shopify
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
